import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// StrictMode double-mounts effects; with Supabase Auth that amplifies session/refresh
// races. Production builds don't use StrictMode from React anyway.
createRoot(document.getElementById('root')!).render(<App />);
